import Backbone from 'backbone';
import Radio from 'backbone.radio';
import ForgotPasswordView from '@/views/login_forgot_password';

    var globalCh = Radio.channel('global');
    var routerCh = Radio.channel('router');
    export default function forgot_password() {
        var controller = globalCh.request('controller');
        var options = globalCh.request('app_options');
        if (options.theme && options.theme.app_title) {
            document.title = options.theme.app_title + " Forgot Password";
        } else {
            document.title = "Electric Imp Forgot Password";
        }
        var app_layout = controller.ensure_login_layout();
        app_layout.showChildView('content', new ForgotPasswordView({
            className: "forgot_password",
            model : new Backbone.Model({ foo: "bar"})
        }));
        routerCh.request('set_location', 'forgot_password');
    }

